export const breakpoints = {
    small: 440,
    medium: 768,
    large: 992,
    xLarge: 1200
};

export const upToSmall = `@media (max-width: ${breakpoints.small}px)`;
export const smallUp = `@media (min-width: ${breakpoints.small}px)`;
export const upToMedium = `@media (max-width: ${breakpoints.medium}px)`;
export const mediumUp = `@media (min-width: ${breakpoints.medium}px)`;
export const upToLarge = `@media (max-width: ${breakpoints.large}px)`;
export const largeUp = `@media (min-width: ${breakpoints.large}px)`;
export const xLargeUp = `@media (min-width: ${breakpoints.xLarge}px)`;
export const smallToLarge = `@media (min-width: ${breakpoints.small}px) and (max-width: ${breakpoints.large}px)`;
export const smallToMedium = `@media (min-width: ${breakpoints.small}px) and (max-width: ${breakpoints.medium}px)`;
export const mediumToLarge = `@media (min-width: ${breakpoints.medium}px) and (max-width: ${breakpoints.large}px)`;
export const largeToXLarge = `@media (min-width: ${breakpoints.large}px) and (max-width: ${breakpoints.xLarge}px)`;

export const mediaQueries = {
    upToSmall,
    upToMedium,
    upToLarge,
    smallUp,
    mediumUp,
    largeUp,
    xLargeUp,
    smallToMedium,
    smallToLarge,
    mediumToLarge,
    largeToXLarge
};
